module.exports = __webpack_public_path__ + "img/sfn_background.bdda46f9.png";